import { z } from 'zod';
const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
// 1) JSON *value* schema (validates already-parsed JSON values)
export const jsonValueSchema = z.lazy(() => z.union([literalSchema, z.array(jsonValueSchema), z.record(z.string(), jsonValueSchema)]));
// 2) JSON *string* schema (parses string -> value, then validates value)
export const jsonSchema = z.preprocess((v) => {
    if (typeof v !== 'string')
        return v;
    try {
        return JSON.parse(v);
    }
    catch {
        return v;
    }
}, jsonValueSchema);
